(() => {
  'use strict';

  const openers = new WeakMap();
  const toastTimers = new WeakMap();

  const syncOverlayLock = () => {
    document.documentElement.classList.toggle('is-overlay-open', Boolean(document.querySelector('dialog[open]')));
  };

  const syncTriggerState = (dialog, expanded) => {
    if (!dialog?.id) return;
    document.querySelectorAll(`[aria-controls="${dialog.id}"]`).forEach((trigger) => {
      trigger.setAttribute('aria-expanded', String(expanded));
    });
  };

  const getDialog = (id) => {
    const element = document.getElementById(id);
    return element instanceof HTMLDialogElement ? element : null;
  };

  const focusFirstControl = (dialog) => {
    const target = dialog.querySelector('[autofocus]') || dialog.querySelector(
      'button:not(:disabled), [href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'
    );
    target?.focus();
  };

  const openDialog = (trigger, restoreTarget = trigger) => {
    const dialog = getDialog(trigger.getAttribute('data-dialog-open'));
    if (!dialog || dialog.open) return;
    openers.set(dialog, restoreTarget);
    dialog.showModal();
    syncTriggerState(dialog, true);
    syncOverlayLock();
    window.requestAnimationFrame(() => focusFirstControl(dialog));
  };

  const closeDialog = (trigger) => {
    const dialog = trigger.closest('dialog');
    if (dialog?.open) dialog.close(trigger.getAttribute('data-dialog-value') || '');
  };

  const showToast = (trigger) => {
    const toast = document.getElementById(trigger.getAttribute('data-toast-trigger'));
    if (!toast) return;
    toast.textContent = trigger.getAttribute('data-toast-message') || 'Your update was saved.';
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimers.get(toast));
    toastTimers.set(toast, window.setTimeout(() => toast.classList.remove('is-visible'), 4200));
  };

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-dialog-open]');
    if (openTrigger) {
      event.preventDefault();
      let restoreTarget = openTrigger;
      if (openTrigger.hasAttribute('data-dialog-close-current')) {
        const currentDialog = openTrigger.closest('dialog');
        if (currentDialog?.open) {
          currentDialog.close();
          restoreTarget = document.activeElement;
        }
      }
      openDialog(openTrigger, restoreTarget);
      return;
    }

    const closeTrigger = event.target.closest('[data-dialog-close]');
    if (closeTrigger) {
      event.preventDefault();
      closeDialog(closeTrigger);
      return;
    }

    const toastTrigger = event.target.closest('[data-toast-trigger]');
    if (toastTrigger) {
      event.preventDefault();
      showToast(toastTrigger);
      return;
    }

    if (event.target instanceof HTMLDialogElement && event.target.hasAttribute('data-close-on-backdrop')) {
      event.target.close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const dialog = document.querySelector('dialog[open]');
    if (!dialog) return;
    event.preventDefault();
    dialog.close();
  });

  document.addEventListener('close', (event) => {
    if (!(event.target instanceof HTMLDialogElement)) return;
    syncTriggerState(event.target, false);
    syncOverlayLock();
    const opener = openers.get(event.target);
    if (opener?.isConnected) opener.focus();
    openers.delete(event.target);
  }, true);
})();
